import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: '100vh',
        width: '100%',
        overflow: 'hidden',
    },
}));
